module.exports = __webpack_public_path__ + "img/jibie_top0_true.2178799e.png";